export const TransfersNumberColums = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 40,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "时间",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: "批次号",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: "SKU",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: "数量",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: '类型',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: '入库名称',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: '出库名称',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: '操作人',
    dataIndex: 'placeholder',
    key: 'placeholder',
  }
];
